module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('router-link', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    attrs: {
      "to": "/admin/business/budgets/create"
    }
  }, [_vm._v("\n          Crear Presupuesto\n        ")])], 1)]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "intro-y box mt-6"
  }, [_c('div', {
    staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n          Presupuesto " + _vm._s(_vm.current.reference) + "\n        ")])]), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkBudget.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.client_id),
      expression: "current.client_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "client_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione Cliente...")]), _vm._v(" "), _vm._l((_vm.clients), function(client) {
    return _c('option', {
      key: ((client.id) + "-client"),
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n              " + _vm._s(client.social_reason) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Ejecutivo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.ejecutive_id),
      expression: "current.ejecutive_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "ejecutive_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione Ejecutivo...")]), _vm._v(" "), _vm._l((_vm.filteredEjecutives), function(ejecutive) {
    return _c('option', {
      key: ((ejecutive.id) + "-ejecutive"),
      domProps: {
        "value": ejecutive.id
      }
    }, [_vm._v("\n              " + _vm._s(ejecutive.name) + " - " + _vm._s(ejecutive.email) + "\n            ")])
  })], 2)]), _vm._v(" "), (_vm.current.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Moneda cambio")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1"
  }, [_vm._v("\n            " + _vm._s(_vm.current.money_code) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.current.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("1 dólar es igual a:")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1"
  }, [_vm._v("\n            " + _vm._s(_vm.current.usd_convertion) + "\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Referencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.reference),
      expression: "current.reference"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.current.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current, "reference", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Razon Social")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.social_reason_id),
      expression: "current.social_reason_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "social_reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetBudgetItems('social_reason_id')
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione la Razon Social")]), _vm._v(" "), _vm._l((_vm.socialreasons), function(socialreason) {
    return _c('option', {
      key: ((socialreason.id) + "-social-reason"),
      domProps: {
        "value": socialreason.id
      }
    }, [_vm._v("\n              " + _vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.account_id),
      expression: "current.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetBudgetItems('account_id')
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una cuenta")]), _vm._v(" "), _vm._l((_vm.filteredAccounts), function(account) {
    return _c('option', {
      key: ((account.id) + "-account"),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n              " + _vm._s(account.name) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.project_id),
      expression: "current.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione un proyecto")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ((project.id) + "-project"),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n              " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n              " + _vm._s(project.account.country.prefix) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.campaign_id),
      expression: "current.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ((campaign.id) + "-campaign"),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n              " + _vm._s(campaign.name) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Tipo de presupuesto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.type),
      expression: "current.type"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.current, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione tipo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cliente"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cargo agencia"
    }
  }, [_vm._v("Cargo Agencia")])])]), _vm._v(" "), (_vm.current.type) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Comision Agencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current.commission_agency),
      expression: "current.commission_agency"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "step": ".01",
      "required": "",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.current.commission_agency)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.current, "commission_agency", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.createNewVersion) ? _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "px-5 sm:px-8 py-5 sm:py-10"
  }, [(!_vm.checked) ? _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 py-5 bg-gray-400 rounded px-2"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Agregar item:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.id),
      expression: "budgetCurrentItem.id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budgetCurrentItem, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredBudgetElements), function(element) {
    return _c('option', {
      key: ((element.id) + "-budget-element"),
      domProps: {
        "value": element.id
      }
    }, [_vm._v("\n                    " + _vm._s(element.name) + " - $ " + _vm._s(_vm.formatPrice(element.value)) + "\n                  ")])
  }), _vm._v(" "), (_vm.filteredBudgetElements.length) ? _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("\n                    Nuevo Elemento\n                  ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3"
  }, [_c('label', [_vm._v("Cantidad:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.quantity),
      expression: "budgetCurrentItem.quantity"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.budgetCurrentItem.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budgetCurrentItem, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3 flex"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button",
      "disabled": !_vm.budgetCurrentItem.id
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("\n                  Agregar\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!_vm.budgetitems.length) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                      No hay Elementos seleccionados\n                    ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.budgetitems), function(item, index) {
    return _c('tr', {
      key: ((item.name) + "-budget-item-" + index),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('td', [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.name),
        expression: "item.name",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "name", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                        " + _vm._s(item.name) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left whitespace-no-wrap"
    }, [_vm._v("\n                          DESCRIPCION:\n                        ")]), _vm._v(" "), (!_vm.checked) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                          " + _vm._s(item.description) + "\n                        ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      staticClass: "input w-full border mt-auto flex-1",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantity", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        " + _vm._s(item.quantity) + "\n                      ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('currency-input', {
      staticClass: "input w-full border mt-2",
      attrs: {
        "id": item.id,
        "locale": "es",
        "precision": 2,
        "valueRange": {
          min: 0
        },
        "distraction-free": {
          hideNegligibleDecimalDigits: true,
        },
        "currency": {
          prefix: '$ '
        }
      },
      on: {
        "blur": function($event) {
          item.unit_value == null ? (item.unit_value = 0) : ''
        }
      },
      model: {
        value: (item.unit_value),
        callback: function($$v) {
          _vm.$set(item, "unit_value", $$v)
        },
        expression: "item.unit_value"
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        $" + _vm._s(_vm.formatPrice(item.unit_value)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left"
    }, [_vm._v("SUBTOTAL:")]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_vm._v("\n                          $ " + _vm._s(_vm.formatPrice(item.quantity * item.unit_value)) + "\n                        ")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.iva),
        expression: "item.iva"
      }],
      staticClass: "input w-full border mt-auto flex-1",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "iva", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), (
      _vm.selectedSocialReason && _vm.selectedSocialReason.iva
    ) ? _c('option', {
      domProps: {
        "value": _vm.selectedSocialReason.iva
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.selectedSocialReason.iva) + "%\n                        ")]) : _vm._e()]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        " + _vm._s(item.iva) + "%\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left whitespace-no-wrap"
    }, [_vm._v("\n                          VALOR IVA:\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                          $\n                          " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value
      )
    )) + "\n                        ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.commission),
        expression: "item.commission"
      }],
      staticClass: "input w-full border mt-auto flex-1 text-center",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "commission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("1%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2.5
      }
    }, [_vm._v("2,5%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("3%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3.2
      }
    }, [_vm._v("3,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("4%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4.2
      }
    }, [_vm._v("4,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 6
      }
    }, [_vm._v("6%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 7.2
      }
    }, [_vm._v("7,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 8
      }
    }, [_vm._v("8%")])]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                        " + _vm._s(item.commission) + "%\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-left whitespace-no-wrap"
    }, [_vm._v("\n                          VALOR COMISION:\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                          $\n                          " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value
      )
    )) + "\n                        ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "whitespace-no-wrap text-center"
    }, [_vm._v("\n                        $\n                        " + _vm._s(_vm.formatPrice(
      item.quantity * item.unit_value +
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value,
        false
      ) +
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value,
        false
      )
    )) + "\n                      ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('button', {
      staticClass: "button bg-theme-6 text-white mt-auto",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.budgetitems.splice(index, 1)
        }
      }
    }, [_vm._v("\n                        Eliminar\n                      ")]) : _vm._e()])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 sm:px-20 pb-10 sm:pb-20 flex flex-col-reverse sm:flex-row"
  }, [_c('div', {
    staticClass: "text-center sm:text-right sm:ml-auto mt-5"
  }, [_c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.current.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.subtotal)) + "\n                  ")])]), _vm._v(" "), (_vm.subtotal) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    USD $ " + _vm._s(_vm.formatPrice(_vm.current.usd_subtotal)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Impuestos subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.current.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.taxSubtotal)) + "\n                  ")])]), _vm._v(" "), (_vm.current.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Impuestos subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    USD $\n                    " + _vm._s(_vm.formatPrice(_vm.taxSubtotal / _vm.current.usd_convertion)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Comision subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    " + _vm._s(_vm.budget.money_code) + " $\n                    " + _vm._s(_vm.formatPrice(_vm.commissionSubtotal)) + "\n                  ")])]), _vm._v(" "), (_vm.current.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                  Comision subtotal:\n                  "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                    USD $\n                    " + _vm._s(_vm.formatPrice(_vm.commissionSubtotal / _vm.current.usd_convertion)) + "\n                  ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL:")]), _vm._v("\n                  " + _vm._s(_vm.current.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.total)) + "\n                ")]), _vm._v(" "), (_vm.total) ? _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL: ")]), _vm._v("\n                  USD $ " + _vm._s(_vm.formatPrice(_vm.current.usd_total)) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-1 tetx-xs"
  }, [_vm._v("Incluye Impuestos")])])])]), _vm._v(" "), (_vm.checked) ? _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-9 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createVersion()
      }
    }
  }, [_vm._v("\n              Confirmar version\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-11 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }, [_vm._v("\n              Editar version\n            ")])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Crear version\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-16 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createNewVersion = !_vm.createNewVersion
      }
    }
  }, [_vm._v("\n              Cancelar\n            ")])])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createNewVersion = !_vm.createNewVersion
      }
    }
  }, [_vm._v("\n            Crear nueva version\n          ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "report-timeline mt-5 relative"
  }, _vm._l((_vm.current.versions), function(version, index) {
    return _c('div', {
      staticClass: "intro-x relative flex items-center mb-3"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "box px-5 py-3 ml-4 flex-1 zoom-in"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', [_c('div', {
      staticClass: "font-medium"
    }, [_vm._v("\n                  Version #" + _vm._s(_vm.current.versions.length - index) + "\n                  "), (!index) ? _c('span', [_vm._v("ACTUAL")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500"
    }, [_vm._v("\n                  Usuario: " + _vm._s(version.user_name) + " - " + _vm._s(version.user_email) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500 ml-auto"
    }, [_vm._v("\n                " + _vm._s(version.created_at) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "accordion accordion-boxed"
    }, [_c('div', {
      staticClass: "accordion-item"
    }, [(version.show) ? _c('div', {
      staticClass: "accordion-collapse collapse show"
    }, [_c('div', {
      staticClass: "overflow-auto"
    }, [_c('table', {
      staticClass: "table table-report -mt-2"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((version.items), function(item, index) {
      return _c('tr', {
        key: ("item-" + (item.id) + "-" + index),
        staticClass: "intro-x"
      }, [_c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-left whitespace-no-wrap"
      }, [_vm._v("\n                                ITEM:\n                              ")]), _vm._v(" "), _c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                              ")]), _vm._v(" "), _c('div', {
        staticClass: "text-left whitespace-no-wrap"
      }, [_vm._v("\n                                DESCRIPCION:\n                              ")]), _vm._v(" "), _c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_c('a', {
        staticClass: "text-white",
        attrs: {
          "data-target": ("#description-" + index),
          "data-toggle": "modal"
        }
      }, [_vm._v("ver más")])])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                " + _vm._s(item.quantity) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.unit_value)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.subtotal)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.iva_value)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.commission_value)) + "\n                              ")])]), _vm._v(" "), _c('td', {
        staticClass: "w-40 text-center"
      }, [_c('div', {
        staticClass: "text-gray-600 text-xs whitespace-no-wrap"
      }, [_vm._v("\n                                $ " + _vm._s(_vm.formatPrice(item.total)) + "\n                              ")])]), _vm._v(" "), _c('div', {
        staticClass: "modal",
        attrs: {
          "id": ("description-" + index)
        }
      }, [_c('div', {
        staticClass: "modal__content modal__content--md"
      }, [_c('div', {
        staticClass: "flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
      }, [_c('h2', {
        staticClass: "font-medium text-base mr-auto"
      }, [_vm._v("\n                                    ITEM: " + _vm._s(item.name) + "\n                                  ")]), _vm._v(" "), _vm._m(4, true)]), _vm._v(" "), _c('div', [_c('div', {
        staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
      }, [_c('div', {
        staticClass: "col-span-12 sm:col-span-12"
      }, [_c('label', [_vm._v("DESCRIPCION:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.description))])])])]), _vm._v(" "), _vm._m(5, true)])])])
    }), 0)])])]) : _vm._e()])])]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              SUBTOTAL: $ " + _vm._s(_vm.formatPrice(version.subtotal)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              SUBTOTAL: USD $ " + _vm._s(_vm.formatPrice(version.usd_subtotal)) + "\n            ")]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: $ " + _vm._s(_vm.formatPrice(version.iva)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: USD $ " + _vm._s(_vm.formatPrice(version.usd_tax)) + "\n            ")]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: $ " + _vm._s(_vm.formatPrice(version.commission)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              IMPUESTOS: USD $ " + _vm._s(_vm.formatPrice(version.usd_commission)) + "\n            ")]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              TOTAL: $ " + _vm._s(_vm.formatPrice(version.total)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 mt-1 text-right"
    }, [_vm._v("\n              TOTAL: USD $ " + _vm._s(_vm.formatPrice(version.usd_total)) + "\n            ")]), _vm._v(" "), (version.items.length) ? _c('div', {
      staticClass: "accordion-header"
    }, [_c('button', {
      staticClass: "accordion-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          version.show = !version.show
        }
      }
    }, [(!version.show) ? _c('span', [_vm._v("Ver")]) : _c('span', [_vm._v("Ocultar")]), _vm._v("\n                (" + _vm._s(version.items.length) + ") items\n              ")])]) : _vm._e()])])
  }), 0)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                      CONCEPTO ITEM\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                      VALOR UNITARIO\n                    ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("IVA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("COMISION")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("ACCIONES")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-x flex items-center h-10"
  }, [_c('h2', {
    staticClass: "text-lg font-medium truncate mr-5"
  }, [_vm._v("\n          Historial de versiones\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-timeline__image"
  }, [_c('div', {
    staticClass: "flex h-10 w-10"
  }, [_c('div', {
    staticClass: "bg-theme-1 h-3 m-auto my-auto rounded-full w-3 z-10"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              CONCEPTO ITEM\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              QTY\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              PRECIO\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              SUBTOTAL\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              IVA\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              COMISION\n                            ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("\n                              TOTAL\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                                    Cerrar\n                                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a2ef22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/budgets/ShowBudget.vue
// module id = 448
// module chunks = 1